/* SplitZero — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Revelados al hacer scroll (un único observer) ---------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 })
    : null;

  function splitWords(el) {
    if (el.dataset.szSplitDone) return;
    el.dataset.szSplitDone = '1';
    var i = 0;
    var base = parseInt(el.dataset.szDelay || '0', 10);
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'sz-w';
            var inner = document.createElement('span'); inner.textContent = p;
            inner.style.setProperty('--d', base + i * 70 + 'ms'); i++;
            w.appendChild(inner); frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    })(el);
  }

  function initReveal(root) {
    root.querySelectorAll('[data-sz-stagger]').forEach(function (wrap) {
      var step = parseInt(wrap.dataset.szStagger || '90', 10);
      wrap.querySelectorAll('.sz-reveal, .sz-reveal--img').forEach(function (el, i) {
        if (!el.style.getPropertyValue('--d')) el.style.setProperty('--d', i * step + 'ms');
      });
    });
    root.querySelectorAll('[data-sz-split]').forEach(function (el) { splitWords(el); el.classList.add('sz-split'); });
    var els = root.querySelectorAll('.sz-reveal, .sz-reveal--img, .sz-split, .sz-steps__line');
    els.forEach(function (el) {
      if (reduced || !io) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* ---------- Hero: zoom de entrada + parallax suave ---------- */
  function initHero(root) {
    root.querySelectorAll('.sz-hero').forEach(function (hero) {
      requestAnimationFrame(function () { setTimeout(function () { hero.classList.add('is-loaded'); }, 60); });
      var k = parseFloat(hero.dataset.parallax || '0');
      if (!k || reduced) return;
      var img = hero.querySelectorAll('.sz-hero__media img');
      var ticking = false, timer;
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var r = hero.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) {
            hero.classList.add('is-scrolling');
            hero.style.setProperty('--par', (-r.top * k) + 'px');
            clearTimeout(timer); timer = setTimeout(function () { hero.classList.remove('is-scrolling'); }, 120);
          }
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(root) {
    root.querySelectorAll('.sz-cmp').forEach(function (cmp) {
      var range = cmp.querySelector('.sz-cmp__range');
      if (!range) return;
      var set = function (v) { cmp.style.setProperty('--pos', v + '%'); };
      range.addEventListener('input', function () { set(range.value); });
      set(range.value);
      if (reduced || !('IntersectionObserver' in window)) return;
      var once = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; once.disconnect();
        var start = performance.now(), from = parseFloat(range.value);
        (function tick(t) {
          var p = Math.min((t - start) / 1800, 1);
          var v = from + Math.sin(p * Math.PI * 2) * 18 * (1 - p);
          set(v); if (p < 1) requestAnimationFrame(tick); else set(range.value);
        })(start);
      }, { threshold: 0.6 });
      once.observe(cmp);
    });
  }

  /* ---------- Escena sticky de tecnología ---------- */
  function initTech(root) {
    root.querySelectorAll('.sz-tech').forEach(function (sec) {
      var panels = sec.querySelectorAll('.sz-tech__panel');
      var imgs = sec.querySelectorAll('.sz-tech__stage img');
      var bars = sec.querySelectorAll('.sz-tech__count span');
      if (!panels.length || !('IntersectionObserver' in window)) return;
      var activate = function (idx) {
        panels.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
        imgs.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
        bars.forEach(function (p, i) { p.classList.toggle('is-active', i <= idx); });
      };
      activate(0);
      var obs = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(panels, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      panels.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCount(root) {
    root.querySelectorAll('[data-sz-count]').forEach(function (el) {
      var target = parseFloat(el.dataset.szCount);
      if (isNaN(target)) return;
      var dec = (el.dataset.szCount.split('.')[1] || '').length;
      if (reduced || !('IntersectionObserver' in window)) { el.textContent = target.toFixed(dec); return; }
      el.textContent = (0).toFixed(dec);
      var obs = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; obs.disconnect();
        var start = performance.now();
        (function tick(t) {
          var p = Math.min((t - start) / 1600, 1), e = 1 - Math.pow(1 - p, 4);
          el.textContent = (target * e).toFixed(dec);
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  /* ---------- Selector de colores (portada) ---------- */
  function initColors(root) {
    root.querySelectorAll('.sz-colors').forEach(function (sec) {
      var sw = sec.querySelectorAll('.sz-swatch');
      var imgs = sec.querySelectorAll('.sz-colors__stage img');
      var name = sec.querySelector('.sz-colors__name');
      var idx = sec.querySelector('.sz-colors__idx');
      var link = sec.querySelector('[data-sz-color-link]');
      var total = sw.length;
      var pick = function (i) {
        var s = sw[i]; if (!s) return;
        sw.forEach(function (x, j) { x.classList.toggle('is-active', j === i); x.setAttribute('aria-pressed', j === i); });
        imgs.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
        sec.style.setProperty('--glow', s.dataset.color);
        if (name) name.innerHTML = '<span>' + s.dataset.name + '</span>';
        if (idx) idx.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
        if (link) {
          if (s.dataset.url) link.setAttribute('href', s.dataset.url);
          var lbl = link.querySelector('[data-sz-label]');
          if (lbl) lbl.textContent = (link.dataset.prefix || 'Shop') + ' ' + s.dataset.name;
        }
      };
      sw.forEach(function (s, i) { s.addEventListener('click', function () { pick(i); }); });
      pick(0);
    });
  }

  /* ---------- Acordeones ---------- */
  function initAcc(root) {
    root.querySelectorAll('.sz-acc__q').forEach(function (q) {
      if (q.dataset.szBound) return; q.dataset.szBound = '1';
      q.addEventListener('click', function () {
        var item = q.closest('.sz-acc__item');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = withComma + '.' + parts[1];
    if (!fmt) return '$' + amount;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function initPDP(root) {
    root.querySelectorAll('[data-sz-pdp]').forEach(function (pdp) {
      var dataEl = pdp.querySelector('[data-sz-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = pdp.dataset.moneyFormat;
      var idInput = pdp.querySelector('input[name="id"]');
      var btn = pdp.querySelector('[data-sz-add]');
      var btnLabel = btn && btn.querySelector('[data-sz-add-label]');
      var priceNow = pdp.querySelector('[data-sz-price]');
      var priceWas = pdp.querySelector('[data-sz-compare]');
      var save = pdp.querySelector('[data-sz-save]');
      var stickyPrice = pdp.querySelector('[data-sz-sticky-price]');

      /* Galería */
      var stage = pdp.querySelectorAll('.sz-gal__stage img');
      var thumbs = pdp.querySelectorAll('.sz-gal__thumb');
      var cur = 0;
      var show = function (i) {
        if (!stage.length) return;
        cur = (i + stage.length) % stage.length;
        stage.forEach(function (x, j) { x.classList.toggle('is-active', j === cur); });
        thumbs.forEach(function (x, j) { x.classList.toggle('is-active', j === cur); });
        if (thumbs[cur] && thumbs[cur].scrollIntoView && pdp.dataset.ready) {
          var wrap = thumbs[cur].parentNode;
          wrap.scrollTo({ left: thumbs[cur].offsetLeft - 20, top: thumbs[cur].offsetTop - 20, behavior: 'smooth' });
        }
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = pdp.querySelector('[data-sz-prev]'), next = pdp.querySelector('[data-sz-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      var st = pdp.querySelector('.sz-gal__stage');
      if (st) {
        var x0 = null;
        st.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        st.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null;
        });
      }
      var showMedia = function (mediaId) {
        if (!mediaId) return;
        stage.forEach(function (x, j) { if (x.dataset.mediaId === String(mediaId)) show(j); });
      };

      /* Variantes */
      var update = function () {
        var sel = [];
        pdp.querySelectorAll('.sz-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('legend b');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        })[0];
        if (!v) {
          if (btn) { btn.setAttribute('disabled', ''); btn.setAttribute('aria-disabled', 'true'); }
          if (btnLabel) btnLabel.textContent = btn.dataset.unavailable;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price, fmt);
        if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = money(v.compare_at_price, fmt); }
        if (save) {
          save.hidden = !onSale;
          if (onSale) save.textContent = (save.dataset.prefix || 'Save') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (btn) {
          if (v.available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
          else { btn.setAttribute('disabled', ''); btn.setAttribute('aria-disabled', 'true'); }
        }
        if (btnLabel) btnLabel.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        if (v.featured_media && (pdp.dataset.ready || /[?&]variant=/.test(window.location.search))) showMedia(v.featured_media.id);
        if (pdp.dataset.ready && window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      };
      pdp.querySelectorAll('.sz-opt input').forEach(function (inp) { inp.addEventListener('change', update); });
      update();
      if (stage.length && !pdp.querySelector('.sz-gal__stage img.is-active')) show(0);
      pdp.dataset.ready = '1';

      /* Cantidad */
      var qty = pdp.querySelector('.sz-qty input');
      pdp.querySelectorAll('[data-sz-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.szQty, 10));
          qty.value = n;
        });
      });

      /* Barra de compra fija */
      var sticky = pdp.querySelector('.sz-sticky');
      var buy = pdp.querySelector('.sz-buy');
      if (sticky && buy && 'IntersectionObserver' in window) {
        var o = new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
        o.observe(buy);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (btn && !btn.hasAttribute('disabled')) btn.click();
          else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll(root) {
    root = root || document;
    initReveal(root); initHero(root); initCompare(root); initTech(root);
    initCount(root); initColors(root); initAcc(root); initPDP(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
